import React, { useState } from 'react';

import i18n from 'i18n-js';
import { Box, Grid, Paper, Button, Divider, IconButton } from '@material-ui/core';
import { DnDtable } from 'components/UI';
import EditIcon from '@material-ui/icons/Edit';
import useStyles from './TaxRulesetTable.styled';
import DeleteIcon from '@material-ui/icons/Delete';
import AddIcon from '@material-ui/icons/AddCircle';
import { TaxRulesetsModal } from 'components/Modals';

export const TaxRulesetTable = ({ taxes = [], onUpdate, onDelete, action }) => {
  const classes = useStyles();
  const [index, setIndex] = useState(null);
  const [current, setCurrent] = useState(null);
  const [openTaxRulesetsModal, setOpenTaxRulesetsModal] = useState(false);

  const columns = [
    {
      name: i18n.t('common.number'),
      selector: 'view_order',
      style: { width: '5%' },
      align: 'center',
      cell: (row) => row?.view_order || '--',
    },
    {
      name: i18n.t('common.location'),
      selector: 'location.name',
      style: { width: '70%' },
      cell: (row) => row?.location?.name || '--',
    },
    {
      name: i18n.t('tax_ruleset.tax'),
      selector: 'rate',
      style: { width: '10%' },
      align: 'right',
      cell: (row) => (row?.rate ? `${row?.rate * 100} %` : '--'),
    },
    ...(action !== 'details'
      ? [
          {
            name: i18n.t('common.actions'),
            selector: 'action',
            cell: (row, index) => {
              return (
                <Box display="flex" justifyContent="center">
                  <IconButton
                    aria-label="edit"
                    size="medium"
                    onClick={() => {
                      setIndex(index);
                      setCurrent(row);
                      handleOpenTaxRulesetsModal();
                    }}
                  >
                    <EditIcon fontSize="inherit" />
                  </IconButton>
                  <IconButton aria-label="delete" size="medium" onClick={() => handleDelete(index)}>
                    <DeleteIcon fontSize="inherit" />
                  </IconButton>
                </Box>
              );
            },
          },
        ]
      : []),
  ];

  /**
   * Handle open/close rules modal
   */
  const handleOpenTaxRulesetsModal = () => {
    setOpenTaxRulesetsModal(!openTaxRulesetsModal);
  };

  /**
   * Handla delete ruleset
   * @param {object} row Ruleset data
   */
  const handleDelete = (index) => {
    onDelete(index);
  };

  const handleUpdate = (data) => {
    onUpdate(data);
  };

  return (
    <Grid item xs={12}>
      <Paper elevation={1} className={classes.paper} data-cy="rulesets-table">
        <DnDtable
          data={taxes}
          columns={columns}
          onUpdate={handleUpdate}
          editable={action === 'details' ? false : true}
        />
        {action !== 'details' && (
          <>
            <Divider />
            <Grid item xs={12}>
              <Grid
                container
                spacing={1}
                direction="row"
                alignItems="center"
                justifyContent="flex-end"
              >
                <Grid item>
                  <Box display="flex" justifyContent="center" fontSize={13}>
                    <Button
                      color="primary"
                      fontSize={13}
                      style={{
                        textTransform: 'capitalize',
                        marginRight: 15,
                      }}
                      onClick={() => {
                        setIndex(null);
                        setCurrent(null);
                        handleOpenTaxRulesetsModal();
                      }}
                      startIcon={<AddIcon />}
                      data-cy="add-tax-btn"
                    >
                      {i18n.t('tax_ruleset.add_tax')}
                    </Button>
                  </Box>
                </Grid>
              </Grid>
            </Grid>
          </>
        )}
      </Paper>
      {openTaxRulesetsModal && (
        <TaxRulesetsModal
          index={index}
          current={current}
          open={openTaxRulesetsModal}
          handleClick={handleOpenTaxRulesetsModal}
        />
      )}
    </Grid>
  );
};
